import {lazy} from 'react';

export const BoxContainerAuthorLazy = lazy(() => import(/* webpackChunkName: "boxContainerAuthor" */ '.'));
